const quotes = [
  {
    id: 1,
    text: "The best way to predict the future is to invent it.",
    author: "Alan Kay",
    category: "Software",
  },
  {
    id: 2,
    text: "Security is not a product, but a process. It's about protecting your systems with the same diligence you protect your physical assets.",
    author: "Carium Tech",
    category: "Cybersecurity",
  },
  {
    id: 3,
    text: "A well-designed network is the nervous system of any modern business. Make it resilient, make it fast, make it secure.",
    author: "Carium Tech",
    category: "Networking",
  },
  {
    id: 4,
    text: "Digital transformation is not about technology — it's about changing the way you do business and deliver value to your customers.",
    author: "Carium Tech",
    category: "Digital Transformation",
  },
  {
    id: 5,
    text: "Web development is an art of balancing form and function, where every pixel and every millisecond matters.",
    author: "Carium Tech",
    category: "Web Development",
  },
  {
    id: 6,
    text: "Cybersecurity is everyone's responsibility. The strongest firewall is a well-trained workforce.",
    author: "Carium Tech",
    category: "Cybersecurity",
  },
  {
    id: 7,
    text: "A CCTV system is only as good as its installation. Precision in placement means clarity in evidence.",
    author: "Carium Tech",
    category: "CCTV Installation",
  },
  {
    id: 8,
    text: "Code is like humor. When you have to explain it, it's bad.",
    author: "Cory House",
    category: "Software",
  },
  {
    id: 9,
    text: "In IT consulting, we don't just fix problems — we anticipate them. Proactive maintenance beats reactive firefighting every time.",
    author: "Carium Tech",
    category: "IT Consulting",
  },
  {
    id: 10,
    text: "The Internet is the first thing that humanity has built that humanity doesn't understand, the largest experiment in anarchy that we have ever had.",
    author: "Eric Schmidt",
    category: "Networking",
  },
  {
    id: 11,
    text: "Your website is the storefront of the digital age. Make it accessible, make it fast, make it unforgettable.",
    author: "Carium Tech",
    category: "Web Development",
  },
  {
    id: 12,
    text: "The only secure system is the one that is powered off, locked in a concrete vault and buried underground. Everything else is a matter of risk management.",
    author: "Gene Spafford",
    category: "Cybersecurity",
  },
  {
    id: 13,
    text: "Effective CCTV isn't about watching — it's about deterrence. A visible camera prevents more incidents than a hidden one ever solves.",
    author: "Carium Tech",
    category: "CCTV Installation",
  },
  {
    id: 14,
    text: "Digital transformation is rewriting the rules of every industry. Adapt, or become irrelevant.",
    author: "Carium Tech",
    category: "Digital Transformation",
  },
  {
    id: 15,
    text: "The best software solutions are invisible — they integrate so seamlessly into your workflow that you forget they're there.",
    author: "Carium Tech",
    category: "Software Solutions",
  },
  {
    id: 16,
    text: "Measurement is the first step that leads to control and eventually to improvement. If you can't measure something, you can't understand it.",
    author: "H. James Harrington",
    category: "IT Consulting",
  },
  {
    id: 17,
    text: "A robust network isn't built on hardware alone — it's built on architecture, redundancy, and constant vigilance.",
    author: "Carium Tech",
    category: "Networking",
  },
  {
    id: 18,
    text: "Every line of code is a liability until proven otherwise. Write less, test more, deploy smarter.",
    author: "Carium Tech",
    category: "Software Solutions",
  },
  {
    id: 19,
    text: "The best CCTV solution is the one that works when you need it most — reliable, redundant, and remotely accessible.",
    author: "Carium Tech",
    category: "CCTV Installation",
  },
  {
    id: 20,
    text: "Technology is best when it brings people together. The true value of any digital system is measured by the human impact it creates.",
    author: "Carium Tech",
    category: "Digital Transformation",
  },
];

export default quotes;
